<template>
	<v-row no-gutters>
		<v-col class="text-center py-0">
			<div>
				<h3 class="choose" style="text-transform: uppercase">Choose App And Action</h3>
			</div>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'FlowTreeBlockNoService',
};
</script>

<style lang="scss" scoped>
h3.choose {
	color: #93a1ba;
	font-weight: 300 !important;
}
</style>
